import { render, staticRenderFns } from "./quiz-questions.vue?vue&type=template&id=3698a955&scoped=true"
import script from "./quiz-questions.vue?vue&type=script&lang=ts"
export * from "./quiz-questions.vue?vue&type=script&lang=ts"
import style0 from "./quiz-questions.vue?vue&type=style&index=0&id=3698a955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698a955",
  null
  
)

export default component.exports